import React, {ReactNode} from 'react'

import L from '../leaflet.js'
import {Stack} from '../../UI/index.js'
import {mapSpacing, mapZIndex} from '../styles.js'
import MapControlCard from './MapControlCard.js'
import MapControlButton from './MapControlButton.js'

interface MapControlsProps {
    map: L.Map | null
    /** Called before zooming with the buttons */
    onZoom?: () => void
    /** More control cards (MapControlCard), below the zoom card */
    children?: ReactNode
}

/** The toolbar at the top left of a map: zoom in and out, and the map's own controls below that */
export default function MapControls({map, onZoom, children}: MapControlsProps) {
    const zoom = (direction: 1 | -1) => {
        if (!map) {
            return
        }

        onZoom?.()

        if (direction === 1) {
            map.zoomIn()
        } else {
            map.zoomOut()
        }
    }

    return (
        <Stack style={{position: 'absolute', left: mapSpacing.inset, top: mapSpacing.inset, zIndex: mapZIndex.controls, gap: mapSpacing.cardGap}}>
            <MapControlCard>
                <MapControlButton icon='mdi mdi-plus' label='Inzoomen' onClick={() => zoom(1)} />
                <MapControlButton icon='mdi mdi-minus' label='Uitzoomen' onClick={() => zoom(-1)} />
            </MapControlCard>

            {children}
        </Stack>
    )
}
